import React from 'react';
import { Home, Hammer, Droplet, Paintbrush, Frame, Tv, ChefHat, Pencil, Building2, CreditCard } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: ChefHat,
      title: 'Custom Kitchens & Cabinets',
      description: 'Bespoke kitchen designs with premium cabinetry tailored to your lifestyle and space.',
      color: '#0070C0',
    },
    {
      icon: Building2,
      title: 'Legal Basements',
      description: 'Complete basement legalization with inspections and city compliance, maximizing your property value.',
      color: '#E52B2B',
    },
    {
      icon: Droplet,
      title: 'Bathroom Renovations',
      description: 'Transform your bathrooms into luxurious, functional spaces with modern fixtures and finishes.',
      color: '#0070C0',
    },
    {
      icon: Tv,
      title: 'Custom TV Walls & Fireplace Units',
      description: 'Modern entertainment centers and fireplace installations that become the focal point of your room.',
      color: '#E52B2B',
    },
    {
      icon: Frame,
      title: 'Flooring Services',
      description: 'Expert installation of hardwood, laminate, tile, and luxury vinyl flooring for every room.',
      color: '#0070C0',
    },
    {
      icon: Paintbrush,
      title: 'Professional Painting',
      description: 'Interior painting services with premium paints and flawless finishes that last.',
      color: '#E52B2B',
    },
    {
      icon: Frame,
      title: 'Wainscotting',
      description: 'Elegant wall paneling that adds sophistication and character to any interior space.',
      color: '#0070C0',
    },
    {
      icon: Pencil,
      title: 'Architectural Drawings',
      description: 'Professional architectural plans and drawings for permits and construction.',
      color: '#E52B2B',
    },
    {
      icon: CreditCard,
      title: 'Financing Available',
      description: 'Flexible financing options to make your dream renovation affordable with convenient payment plans.',
      color: '#0070C0',
    },
    {
      icon: Hammer,
      title: 'Complete Interior Renovations',
      description: 'Full-scale renovation services for residential and commercial properties of any size.',
      color: '#E52B2B',
    },
  ];

  return (
    <section id="services" className="py-24 bg-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-blue-50/30 rounded-full blur-3xl -z-10" />
      <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-red-50/20 rounded-full blur-3xl -z-10" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-blue-50 rounded-full border border-blue-100 mb-6">
            <span className="text-[#0070C0] font-semibold text-sm">OUR SERVICES</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Complete Interior Renovation Solutions
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            From concept to completion, we handle every aspect of your renovation project with
            expertise and attention to detail.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className="group relative bg-white p-8 rounded-2xl border border-gray-200 hover:border-transparent hover:shadow-2xl transition-all duration-500 overflow-hidden"
              >
                {/* Hover Background Effect */}
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10"
                  style={{
                    background: `linear-gradient(135deg, ${service.color}08 0%, ${service.color}15 100%)`,
                  }}
                />

                {/* Icon Container */}
                <div
                  className="w-16 h-16 rounded-xl flex items-center justify-center mb-6 transition-transform duration-500 group-hover:scale-110 group-hover:rotate-3"
                  style={{
                    backgroundColor: `${service.color}15`,
                  }}
                >
                  <Icon
                    className="w-8 h-8 transition-colors duration-300"
                    style={{ color: service.color }}
                  />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold mb-3 text-gray-900 group-hover:text-[#0070C0] transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>

                {/* Decorative Element */}
                <div
                  className="absolute bottom-0 left-0 h-1 w-0 group-hover:w-full transition-all duration-500"
                  style={{ backgroundColor: service.color }}
                />
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <p className="text-lg text-gray-600 mb-6">
            Don't see what you're looking for? We handle all types of interior renovations!
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center px-8 py-4 bg-[#0070C0] hover:bg-[#005A9C] text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 group"
          >
            Discuss Your Project
            <Hammer className="ml-2 w-5 h-5 group-hover:rotate-12 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
